import { Field } from "react-final-form";
import { useIntl } from "react-intl";
import Section from "../../../common/section";
import * as Validations from "../../../common/form/validator";
import { IconCheckBox, TextInput } from "../../../common/fields";
import Label from "../../../common/fields/Label";

const RoleDetailsForm = ({ disabled = false }) => {
  const intl = useIntl();
  return (
    <div className="flex flex-column gap-4">
      <Section title="basic_info">
        <div className="col-12 md:col-6 lg:col-4">
          <Field
            name="name"
            component={TextInput}
            type="text"
            label={intl.formatMessage({
              id: "name",
            })}
            disabled={disabled}
            placeholder={intl.formatMessage({
              id: "name",
            })}
            required
            validate={Validations.composeValidators(Validations.required)}
          />
        </div>
      </Section>
      <Section title="permissions">
        <div className="col-12">
          <div className="flex flex-row gap-6 flex-wrap">
            <div className="flex flex-column gap-2">
              <Label label={intl.formatMessage({ id: "user_scope" })} />
              <div className="flex gap-4">
                <Field
                  name="scopes['UserAccess'].Read"
                  component={IconCheckBox}
                  checkedIcon="pi-eye"
                  unCheckIcon="pi-eye"
                  type="checkbox"
                  disabled={disabled}
                />
                <Field
                  name="scopes['UserAccess'].Create"
                  component={IconCheckBox}
                  checkedIcon="pi-plus"
                  unCheckIcon="pi-plus"
                  type="checkbox"
                  disabled={disabled}
                />
                <Field
                  name="scopes['UserAccess'].Update"
                  component={IconCheckBox}
                  checkedIcon="pi-pencil"
                  unCheckIcon="pi-pencil"
                  type="checkbox"
                  disabled={disabled}
                />
                <Field
                  name="scopes['UserAccess'].Delete"
                  component={IconCheckBox}
                  checkedIcon="pi-trash"
                  unCheckIcon="pi-trash"
                  type="checkbox"
                  disabled={disabled}
                />
              </div>
            </div>
            <div className="flex flex-column gap-2">
              <Label label={intl.formatMessage({ id: "enterprise_scope" })} />
              <div className="flex gap-4">
                <Field
                  name="scopes['EnterpriseAccess'].Read"
                  component={IconCheckBox}
                  checkedIcon="pi-eye"
                  unCheckIcon="pi-eye"
                  type="checkbox"
                  disabled={disabled}
                />
                <Field
                  name="scopes['EnterpriseAccess'].Create"
                  component={IconCheckBox}
                  checkedIcon="pi-plus"
                  unCheckIcon="pi-plus"
                  type="checkbox"
                  disabled={disabled}
                />
                <Field
                  name="scopes['EnterpriseAccess'].Update"
                  component={IconCheckBox}
                  checkedIcon="pi-pencil"
                  unCheckIcon="pi-pencil"
                  type="checkbox"
                  disabled={disabled}
                />
                <Field
                  name="scopes['EnterpriseAccess'].Delete"
                  component={IconCheckBox}
                  checkedIcon="pi-trash"
                  unCheckIcon="pi-trash"
                  type="checkbox"
                  disabled={disabled}
                />
              </div>
            </div>
            <div className="flex flex-column gap-2">
              <Label label={intl.formatMessage({ id: "content_scope" })} />
              <div className="flex gap-4">
                <Field
                  name="scopes['ContentAccess'].Read"
                  component={IconCheckBox}
                  checkedIcon="pi-eye"
                  unCheckIcon="pi-eye"
                  type="checkbox"
                  disabled={disabled}
                />
                <Field
                  name="scopes['ContentAccess'].Create"
                  component={IconCheckBox}
                  checkedIcon="pi-plus"
                  unCheckIcon="pi-plus"
                  type="checkbox"
                  disabled={disabled}
                />
                <Field
                  name="scopes['ContentAccess'].Update"
                  component={IconCheckBox}
                  checkedIcon="pi-pencil"
                  unCheckIcon="pi-pencil"
                  type="checkbox"
                  disabled={disabled}
                />
                <Field
                  name="scopes['ContentAccess'].Delete"
                  component={IconCheckBox}
                  checkedIcon="pi-trash"
                  unCheckIcon="pi-trash"
                  type="checkbox"
                  disabled={disabled}
                />
              </div>
            </div>
          </div>
        </div>
      </Section>
    </div>
  );
};

export default RoleDetailsForm;
